
  <div class="fixed-width">
    <header>
      <app-header-nav></app-header-nav>
    </header>
    <main>
      <router-outlet></router-outlet>
    </main>
    <footer>
      <app-footer-nav></app-footer-nav>
    </footer>
  </div>
